module.exports = __webpack_public_path__ + "static/media/01-homepage.aa096335.png";